var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgRar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#D34D59",
  fillRule: "evenodd",
  d: "M9 0h7l6 6v15a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16 0v4a2 2 0 0 0 2 2h4z",
  opacity: 0.6
})), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 8,
  x: 2,
  y: 13,
  fill: "#F7F8FA",
  rx: 2
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#D34D59",
  d: "M3.5 19v-4h1.756q.477 0 .824.162.348.16.538.461.188.3.188.709 0 .416-.193.707-.191.29-.548.441-.354.15-.84.15h-1.11v-.76h.919q.232 0 .388-.058a.5.5 0 0 0 .239-.175.53.53 0 0 0 .08-.305.54.54 0 0 0-.08-.307.5.5 0 0 0-.239-.183 1.1 1.1 0 0 0-.388-.063h-.507V19zm2.393-1.828L6.952 19H5.83l-1.038-1.828zM8.874 19H7.77l1.434-4h1.368l1.434 4h-1.104l-.999-2.992H9.87zm-.147-1.574h2.308v.734H8.727zM13.048 19v-4h1.756q.478 0 .824.162.35.16.538.461.189.3.189.709 0 .416-.193.707-.194.29-.548.441-.355.15-.84.15h-1.111v-.76h.92q.232 0 .387-.058a.5.5 0 0 0 .239-.175.53.53 0 0 0 .08-.305.54.54 0 0 0-.08-.307.5.5 0 0 0-.239-.183 1.1 1.1 0 0 0-.388-.063h-.506V19zm2.393-1.828L16.5 19h-1.12l-1.039-1.828z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgRar);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;